module.exports = __webpack_public_path__ + "img/icon_expand_white.fa77e2f9.svg";